import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { QueryParamsModel } from 'src/app/core/models/query-params.model';
import { ErrorService } from 'src/app/services/error.service';
import { environment } from 'src/environments/environment';
import * as SettlementDeedsActions from '../actions/settlement-deeds.actions';
import { AppState } from '../app.reducer';

@Injectable()
export class SettlementDeedsEffects {
  constructor(
    public actions$: Actions,
    public http: HttpClient,
    private errorService: ErrorService,
    private store: Store<AppState>
  ) { }
  payloadReload;

  getSettlementDeeds$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SettlementDeedsActions.getSettlementDeeds),
      switchMap((payload) => {
        const query = { ...payload.payload, filters: JSON.stringify(payload.payload.filters) };
        this.store.dispatch(SettlementDeedsActions.settlementDeedsLoading({ payload: { loading: true } }));
        this.payloadReload = payload.payload;
        const queryPayload = {
          sortOrder: query.sortOrder,
          sortField: query.sortField,
          pageNumber: (query.pageNumber + 1).toString(),
          pageSize: query.pageSize.toString(),
        };
        if (query.filters !== '[]') {
          queryPayload['filters'] = query.filters;
        }

        return this.http
          .get<{ data: any[]; query: QueryParamsModel; totalCount: number }>(
            environment.apiUrl + '/settlementDeeds',
            {
              params: queryPayload,
            }
          )
          .pipe(
            switchMap((responseData) => {
              this.store.dispatch(
                SettlementDeedsActions.getSettlementDeedsSuccess({
                  payload: {
                    settlementDeeds: responseData.data,
                    totalCount: +responseData.totalCount,
                  },
                })
              );
              return of(SettlementDeedsActions.settlementDeedsLoading({ payload: { loading: false } }));
            }),
            catchError((error) => {
              this.store.dispatch(
                SettlementDeedsActions.settlementDeedsFail({ payload: { error: this.errorService.mapError(error) } })
              );
              return of(SettlementDeedsActions.settlementDeedsLoading({ payload: { loading: false } }));
            })
          );
      })
    )
  );
}
